import React from "react";
import "../../../svg.css";

const UCBuildBrandFlow = props => {
  let c1 = "green";
  let c2 = "green";
  let c3 = "green";
  let c4 = "green";
  let c5 = "green";
  let c6 = "green";
  let c7 = "green";
  let c8 = "green";
  let c9 = "green";
  let c10 = "green";
  let c11 = "green";
    if (props.modelno["Brand"][0] !== "#") c1 = "nblack";
    if (props.modelno["Product Identifier"][0] !== "#") c2 = "nblack";
    if (props.modelno["Evaporator Style"][0] !== "#") c3 = "nblack";
    if (props.modelno["BTU Capacity"][0] !== "#") c4 = "nblack";
    if (props.modelno["Voltage"][0] !== "#") c5 = "nblack";
    if (props.modelno["Application"][0] !== "#") c6 = "nblack";
    if (props.modelno["Fins Per Inch"][0] !== "#") c7 = "nblack";
    if (props.modelno["Defrost"][0] !== "#") c8 = "nblack";
    if (props.modelno["Motor"][0] !== "#") c9 = "nblack";
    if (props.modelno["Revision"][0] !== "#") c10 = "nblack";
    if (props.modelno["Option Packages"][0] !== "#") c11 = "nblack";

     return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1090 150">
      <g transform="translate(0,-147)">
        <g>
          <rect
            className="background"
            id="rect1385"
            width="1086.626"
            height="147.12982"
            x="1.9048069"
            y="148.58098"
          />
          <rect
            className="boxrect"
            id="rect815"
            width="69.490074"
            height="96.217026"
            x="12.828938"
            y="189.04463"
            ry="4.2763124"
          />
          <rect
            className="boxrect"
            id="rect815-5"
            width="69.490074"
            height="96.217026"
            x="85"
            y="189.04463"
            ry="3.7417734"
          />
          <rect
            className="boxrect"
            id="rect815-5-4"
            width="69.490074"
            height="96.217026"
            x="158"
            y="189.04462"
            ry="3.7797618"
          />
          <rect
            className="boxrect"
            id="rect815-5-4-3"
            width="185"
            height="96.035805"
            x="230.85214"
            y="189.13524"
            ry="4.3467264"
          />
          <rect
            className="boxrect"
            id="rect815-59"
            width="69.490074"
            height="96.217026"
            x="420"
            y="187.95404"
            ry="3.96875"
          />
          <rect
            className="boxrect"
            id="rect815-5-3"
            width="69.490074"
            height="96.217026"
            x="492"
            y="187.95404"
            ry="3.7797618"
          />
          <rect
            className="boxrect"
            id="rect815-5-4-5"
            width="69.490074"
            height="96.217026"
            x="565"
            y="187.95403"
            ry="3.96875"
          />
          <rect
            className="boxrect"
            id="rect815-5-3-2"
            width="69.490074"
            height="96.217026"
            x="638"
            y="187.95403"
            ry="3.96875"
          />
          <rect
            className="boxrect"
            id="rect815-5-4-5-9"
            width="69.490074"
            height="96.217026"
            x="712"
            y="187.95401"
            ry="3.7797618"
          />
          <rect
            className="boxrect"
            id="rect815-5-4-3-5"
            width="69.490074"
            height="96.217026"
            x="785"
            y="188.1494"
            ry="3.7797618"
          />
          <rect
            className="boxrect"
            id="rect815-5-4-3-5"
            width="258.46964"
            height="95.969757"
            x="860.84753"
            y="188.1494"
            ry="3.7797618"
          />
        </g>
        <text className="textbig" x="21.667826" y="268.27139" id="text926">
          {props.modelno["Brand"]}
        </text>
        <text className="textbig" x="97.363815" y="267.4642" id="text926-7">
          {props.modelno["Product Identifier"]}
        </text>
        <text className="textbig" x="172.58107" y="267.84216" id="text926-0">
          {props.modelno["Evaporator Style"]}
        </text>
        <text className="textbig" x="240" y="267.57397" id="text926-0-5-6">
          {props.modelno["BTU Capacity"].split("_")[0]}
        </text>
        <text className="textbig" x="432.50986" y="267.9921" id="text926-0-52">
          {props.modelno["Voltage"]}
          </text>
        <text className="textbig" x="508.20721" y="268.12576" id="text926-0-7">
          {props.modelno["Application"]}
        </text>
        <text className="textbig" x="582.11627" y="267.99213" id="text926-0-1">
          {props.modelno["Fins Per Inch"]}
        </text>
        <text className="textbig" x="653.69354" y="268.12576" id="text926-0-13">
          {props.modelno["Defrost"]}
        </text>
        <text className="textbig" x="725.12354" y="267.85849" id="text926-0-4">
          {props.modelno["Motor"]}
        </text>
         <text className="textbig" x="800.5524" y="267.85849" id="text926-0-5">
          {props.modelno["Revision"]}
        </text>

        <text className="textbig" x="870" y="267.46814" id="text926-0-58">
          {props.modelno["Option Packages"]}
        </text>

        <circle
          className={"circle-large " + c1}
          id="path1044"
          cx="45.146084"
          cy="171.67307"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c2}
          id="path1044-9"
          cx="122.94398"
          cy="171.91786"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c3}
          id="path1044-7"
          cx="195.6413"
          cy="171.39948"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c4}
          id="path1044-0"
          cx="334.44916"
          cy="171.17267"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c5}
          id="path1044-0-7"
          cx="460.73975"
          cy="171.91786"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c6}
          id="path1044-0-2"
          cx="530.64429"
          cy="171.90712"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c7}
          id="path1044-0-2-4"
          cx="608.33624"
          cy="171.91786"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c8}
          id="path1044-0-2-4-7"
          cx="680.65155"
          cy="171.91786"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c9}
          id="path1044-0-2-4-9"
          cx="750.61615"
          cy="171.65059"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c10}
          id="path1044-0-2-4-8"
          cx="820.73915"
          cy="171.91785"
          r="9.9646921"
        />
        <circle
          className={"circle-large " + c11}
          id="path1044-0-2-4-10"
          cx="953.08313"
          cy="171.91785"
          r="9.9646921"
        />
        <path
          className={"line " + c2}
          d="M 55.057521,171.91786 H 113.05501"
          id="path1142"
        />
        <path
          className={"line " + c3}
          d="m 132.96405,171.91786 h 52.80032"
          id="path1142-6"
        />
        <path
          className={"line " + c4}
          d="M 205.67723,171.91786 H 324.62339"
          id="path1142-6-0"
        />
        <path
          className={"line " + c5}
          d="M 344.0165,171.91786 H 465.98646"
          id="path1142-6-0-4"
        />
        <path
          className={"line " + c6}
          d="m 470.31394,171.88988 h 56.48893"
          id="path1142-6-0-4-9"
        />
        <path
          className={"line " + c7}
          d="m 543.35211,171.88988 h 53.54897"
          id="path1142-6-0-4-9-7"
        />
        <path
          className={"line " + c8}
          d="m 618.04943,171.88988 h 58.89436"
          id="path1142-6-0-4-9-8"
        />
        <path
          className={"line " + c9}
          d="m 688.77786,171.88988 h 52.89816"
          id="path1142-6-0-4-9-80"
        />
        <path
          className={"line " + c10}
          d="m 760.77786,171.88988 h 52.89816"
          id="path1142-6-0-4-9-80"
        />
         <path
          className={"line " + c11}
          d="M 815.44378,171.88988 H 943.70951"
          id="path1142-6-0-4-9-80-6"
        />
        <ellipse
          className="circle-small"
          id="path1248"
          cx="45.321636"
          cy="171.75941"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0"
          cx="123.20588"
          cy="171.91786"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2"
          cx="195.41368"
          cy="171.66309"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3"
          cx="334.48782"
          cy="171.11606"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0"
          cx="460.64526"
          cy="171.63438"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9"
          cx="530.37701"
          cy="171.91785"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9-0"
          cx="608.00751"
          cy="171.78423"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9-0-1"
          cx="680.5733"
          cy="172.01234"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9-0-1-3"
          cx="750.72949"
          cy="171.56158"
          rx="4.3540068"
          ry="4.3540072"
        />
         <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9-0-1-3"
          cx="820.73915"
          cy="171.56158"
          rx="4.3540068"
          ry="4.3540072"
        />
        <ellipse
          className="circle-small"
          id="path1248-0-2-3-0-9-0-1-3-9"
          cx="953.06689"
          cy="171.69644"
          rx="4.3540068"
          ry="4.3540072"
        />
      </g>
    </svg>
  ); 
};

export default UCBuildBrandFlow;
